var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.status
    ? _c(_vm.name, { tag: "component", attrs: { id: "modal" } })
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }